import { Flex, SimpleGrid } from "@chakra-ui/react";
import ButtonComp from "components/Button";
import { Header } from "components/Header";
import InputComp from "components/InputComp";
import Layout from "components/Layout";
import { toaster } from "components/ui/toaster";
import useCheckMobileScreen from "hooks/useCheckMobileScreen";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "services/api";

function CoverTypesManage() {
  const [isLoading, setIsLoading] = useState(false);
  const [covertype, setCovertype] = useState("");

  const navigate = useNavigate();
  const ismobile = useCheckMobileScreen();
  const location = useLocation();
  const action = location.state?.action;
  const itemData = location.state?.data;

  const onNew = async () => {
    setIsLoading(true);
    const res = await api.addCovertype({
      covertype,
    });

    setIsLoading(false);
    toaster.create({
      title: res?.response?.data?.message || res?.data?.message || res?.message,
      type: res?.status === 200 ? "success" : "error",
    });

    if (res?.status === 200) {
      navigate("/covertypes", {
        state: {},
      });
    }
  };

  const onSave = async () => {
    setIsLoading(true);
    const res = await api.updateCovertype({
      coverid: itemData?.coverid,
      covertype,
    });

    setIsLoading(false);
    toaster.create({
      title: res?.response?.data?.message || res?.data?.message || res?.message,
      type: res?.status === 200 ? "success" : "error",
    });

    if (res?.status === 200) {
      navigate("/covertypes", {
        state: {},
      });
    }
  };

  useEffect(() => {
    console.log("itemdata", itemData);

    setCovertype(itemData?.covername);
  }, [itemData]);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header
        label={"Cover Types"}
        // ${
        // action === "duration-edit"
        //   ? `${itemData?.policynumber ? " - " + itemData?.policynumber : ""}`
        //   : ""
        // }`}
        isLoading={isLoading}
      />
      <Layout>
        <Flex
          flex={1}
          // maxW={"26rem"}
          direction={"column"}
          overflow={"scroll"}
          gap={"0.6rem"}
          justifyContent={"space-between"}
        >
          <SimpleGrid
            columns={ismobile ? 1 : 1}
            // maxWidth={"25rem"}
            columnGap="1rem"
            rowGap="1rem"
          >
            <InputComp
              type={"text"}
              label={"Cover Type"}
              value={covertype}
              onChange={setCovertype}
            />
          </SimpleGrid>
        </Flex>
      </Layout>
      <Flex flexFlow={"wrap"} mt={"1rem"} gap={"1rem"} alignSelf={"end"}>
        {action === "covertypesmanage-edit" ? (
          <ButtonComp
            label="Save"
            onClick={onSave}
            keyname="save"
            disabled={isLoading}
          />
        ) : (
          <ButtonComp
            label="Add"
            onClick={onNew}
            keyname="add"
            disabled={isLoading}
          />
        )}
      </Flex>
    </Flex>
  );
}

export default CoverTypesManage;
